import * as React from 'react'
import { cn } from '../../utils/lib/utils'
import PropTypes from 'prop-types'
import { Button } from './button'

export const ActionGroup = React.forwardRef(({ 
  actions = [],
  variant = 'ghost',
  size = 'sm',
  className,
  ...props 
}, ref) => {
  return (
    <div
      ref={ref}
      className={cn('flex items-center gap-2', className)}
      {...props}
    >
      {actions.map((action, index) => (
        <Button
          key={index}
          variant={action.variant || variant}
          size={action.size || size}
          onClick={action.onClick}
          title={action.label}
        >
          {action.icon && <action.icon className="h-4 w-4" />}
          {action.label && <span className="sr-only">{action.label}</span>}
        </Button>
      ))}
    </div>
  )
})

ActionGroup.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.elementType,
    label: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string,
    size: PropTypes.string
  })),
  variant: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string
}

ActionGroup.displayName = 'ActionGroup' 